<template>
  <div class="receiver-list">
    <div class="header">
      <div class="search-ipt">
        <input type="text" v-model="searchKey" placeholder="客户名称" />
        <i @click="search" class="huixiaopiaofont">&#xe6f5;</i>
      </div>
    </div>
    <Address
      v-for="(receiver, index) in receiverList"
      :key="index"
      :onClick="selectReceiver"
      :dataSource="receiver"
      editorLink='/invoice/add-receiver'
    />
  </div>
</template>

<script>
import {
  Notify
} from 'vant'

import Address from '@components/Address/index.vue'
import { invoiceRequest } from '@services'

export default {
  data () {
    return {
      receiverList: [],
      searchKey: ''
    }
  },
  mounted () {
    this.getReceivers()
  },
  methods: {
    search () {
      this.getReceivers()
    },
    selectReceiver (receiver) {
      this.$store.commit('invoice/changeApplyData', {
        formData: {
          receiverName: receiver.userName,
          receiverAddress: receiver.address,
          receiverPhone: receiver.telephone,
          receiverEmail: receiver.email,
          receiverId: receiver.id
        }
      })
      this.$router.go(-1)
    },
    async getReceivers () {
      const postData = {
        merchantId: this.$route.query.merchantId,
        userName: this.searchKey,
        size: 9999
      }
      const data = await invoiceRequest.customer.getReceiverList(postData)
      if (data.success) {
        this.receiverList = data.result.records
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }

  },
  components: {
    Address
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
